import React from "react";
import Close from "../../Atomos/Icons/Close";
import Modal from "./Modal";
import RadioButton from "../Radio/RadioButton";
import useViewport from "../../../hooks/useViewPort";
import Excel from "../Icons/Excel";
import LegacyButton from "../Buttons/LegacyButton";

type propTypes = {
  open: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
  dataExcelExport: (currentData: boolean) => void;
};


const ExcelModal: React.FC<propTypes> = ({ open, setOpen, dataExcelExport }) => {
  const { viewportWidth } = useViewport()
  const [selectedOption, setSelectedOption] = React.useState("currentData");

  const handleSelection = (selectionType: string) => {
    setSelectedOption(selectionType);
  };
  
  return (
    <Modal
      title="Export to Excel"
      isModalOpen={open}
      toggleModal={() => setOpen(false)}
      compact
      className="!max-w-[28rem]"
    >
      <div className="flex flex-col gap-4">

        <p className="text-gray-font text-base leading-6 not-italic font-normal">
          Please select the Data Set you want to export to Excel:
        </p>
        <RadioButton 
          index={0} 
          text={"Current Data Set in Table (Filtered/Current View)"} 
          selected={selectedOption === "currentData"} 
          handleRadioButtonChange={() => handleSelection("currentData")}
          name="excelSelection"
          fontSize="flex-1 text-sm md:text-base leading-6 font-normal not-italic text-gray-font"
          radioSize="w-5 h-5 p-[.2rem]"
        />
        <RadioButton 
          index={1} 
          text={"All Data (Complete Table/All Pages/Unfiltered)"} 
          selected={selectedOption === "totalData"} 
          handleRadioButtonChange={() => handleSelection("totalData")}
          name="excelSelection"
          fontSize="flex-1 text-sm md:text-base leading-6 font-normal not-italic text-gray-font"
          radioSize="w-5 h-5 p-[.2rem]"
        />
        <div className="flex justify-end gap-3 pt-2">
          <LegacyButton onClick={() => setOpen(false)}
            text={"Cancel"}
            icon={<div className=" h-5 w-5"><Close /></div>}
            color='neutral'
            content='textIcon'
            style="outlined"
            className="!min-w-[110px] md:!min-w-[120px]"
          />
          <LegacyButton
            text={viewportWidth < 1024 ? `Export` : `Export to Excel`}
            color="excel"
            content="textIcon"
            onClick={() => dataExcelExport(selectedOption === "currentData")}
            className="!min-w-[110px] md:!min-w-[140px]"
            icon={<div className="w-5 h-5 ml-2 flex items-center justify-center">
              <Excel />
              </div>
            }
          />
        </div>

      </div>
    </Modal>
  );
};

export default ExcelModal;
